var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamPeoples(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 519,
    height: 238,
    viewBox: "0 0 519 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1227_33709)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.326 53.4749C459.326 23.9415 435.385 0 405.852 0H426.309C455.842 0 479.784 23.9415 479.784 53.4749H459.326ZM405.852 106.95C435.385 106.95 459.326 83.0087 459.326 53.4754H479.784C479.784 83.0087 455.842 106.95 426.309 106.95H405.852ZM498.64 237.944C498.64 169.069 457.097 113.236 405.852 113.236H426.309C477.554 113.236 519.097 169.069 519.097 237.944H498.64Z",
    fill: "url(#paint0_linear_1227_33709)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.851 106.95C435.384 106.95 459.326 83.0083 459.326 53.4749C459.326 23.9415 435.384 0 405.851 0C376.318 0 352.376 23.9415 352.376 53.4749C352.376 83.0083 376.318 106.95 405.851 106.95ZM313.062 237.944C313.062 169.069 354.605 113.236 405.851 113.236C457.096 113.236 498.639 169.069 498.639 237.944H313.062Z",
    fill: "url(#paint1_linear_1227_33709)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.851 0C376.318 0 352.376 23.9415 352.376 53.4749H372.833C372.833 23.9415 396.775 0 426.308 0H405.851ZM405.851 113.236C354.605 113.236 313.062 169.069 313.062 237.944H333.52C333.52 169.069 375.063 113.236 426.308 113.236H405.851ZM405.851 106.95C376.318 106.95 352.376 83.0087 352.376 53.4754H372.833C372.833 83.0087 396.775 106.95 426.308 106.95H405.851Z",
    fill: "#080015"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.819 53.4749C171.819 23.9415 147.877 0 118.344 0H138.801C168.334 0 192.276 23.9415 192.276 53.4749H171.819ZM118.344 106.95C147.877 106.95 171.819 83.0087 171.819 53.4754H192.276C192.276 83.0087 168.334 106.95 138.801 106.95H118.344ZM211.132 237.944C211.132 169.069 169.589 113.236 118.344 113.236H138.801C190.047 113.236 231.589 169.069 231.589 237.944H211.132Z",
    fill: "url(#paint2_linear_1227_33709)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.343 106.95C147.876 106.95 171.818 83.0083 171.818 53.4749C171.818 23.9415 147.876 0 118.343 0C88.8097 0 64.8682 23.9415 64.8682 53.4749C64.8682 83.0083 88.8097 106.95 118.343 106.95ZM25.5547 237.944C25.5547 169.069 67.0975 113.236 118.343 113.236C169.589 113.236 211.131 169.069 211.131 237.944H25.5547Z",
    fill: "url(#paint3_linear_1227_33709)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.11
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.343 0C88.8097 0 64.8682 23.9415 64.8682 53.4749H85.3255C85.3255 23.9415 109.267 0 138.8 0H118.343ZM118.343 113.236C67.0975 113.236 25.5547 169.069 25.5547 237.944H46.012C46.012 169.069 87.5548 113.236 138.8 113.236H118.343ZM118.343 106.95C88.8097 106.95 64.8682 83.0087 64.8682 53.4754H85.3255C85.3255 83.0087 109.267 106.95 138.8 106.95H118.343Z",
    fill: "#080015"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.689 53.4749C331.689 83.0083 307.748 106.95 278.215 106.95C248.681 106.95 224.74 83.0083 224.74 53.4749C224.74 23.9415 248.681 0 278.215 0C307.748 0 331.689 23.9415 331.689 53.4749ZM185.426 237.944C185.426 237.944 185.426 237.944 185.426 237.944H164.969C164.969 169.07 206.512 113.236 257.757 113.236H278.092C278.133 113.236 278.174 113.236 278.215 113.236C329.46 113.236 371.003 169.069 371.003 237.944H185.426Z",
    fill: "#0C031D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.233 53.4749C311.233 23.9415 287.291 0 257.758 0H278.215C307.748 0 331.69 23.9415 331.69 53.4749H311.233ZM257.758 106.95C287.291 106.95 311.233 83.0087 311.233 53.4754H331.69C331.69 83.0087 307.748 106.95 278.215 106.95H257.758ZM350.546 237.944C350.546 169.069 309.003 113.236 257.758 113.236H278.215C329.461 113.236 371.004 169.069 371.004 237.944H350.546Z",
    fill: "url(#paint4_linear_1227_33709)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.757 106.95C287.291 106.95 311.232 83.0083 311.232 53.4749C311.232 23.9415 287.291 0 257.757 0C228.224 0 204.282 23.9415 204.282 53.4749C204.282 83.0083 228.224 106.95 257.757 106.95ZM164.969 237.944C164.969 169.069 206.512 113.236 257.757 113.236C309.003 113.236 350.546 169.069 350.546 237.944H164.969Z",
    fill: "url(#paint6_linear_1227_33709)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.11
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.757 0C228.224 0 204.282 23.9415 204.282 53.4749H224.74C224.74 23.9415 248.681 0 278.214 0H257.757ZM257.757 113.236C206.512 113.236 164.969 169.069 164.969 237.944H185.426C185.426 169.069 226.969 113.236 278.214 113.236H257.757ZM257.757 106.95C228.224 106.95 204.282 83.0087 204.282 53.4754H224.74C224.74 83.0087 248.681 106.95 278.214 106.95H257.757Z",
    fill: "#080015"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1227_33709",
    x1: 462.474,
    y1: 0,
    x2: 462.474,
    y2: 237.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B58FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880979,
    stopColor: "#7551FF",
    stopOpacity: 0.61
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1227_33709",
    x1: 464.345,
    y1: 54.9786,
    x2: 313.062,
    y2: 203.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A58FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1227_33709",
    x1: 174.967,
    y1: 0,
    x2: 174.967,
    y2: 237.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B58FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880979,
    stopColor: "#7551FF",
    stopOpacity: 0.61
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1227_33709",
    x1: 176.837,
    y1: 54.9786,
    x2: 25.5547,
    y2: 203.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A58FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1227_33709",
    x1: 314.381,
    y1: 0,
    x2: 314.381,
    y2: 237.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B58FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880979,
    stopColor: "#7551FF",
    stopOpacity: 0.61
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1227_33709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(362.993 270.222) scale(131.3 178.321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1227_33709",
    x1: 316.252,
    y1: 54.9786,
    x2: 164.969,
    y2: 203.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A58FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1227_33709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.786 237.763) scale(131.3 148.658)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1227_33709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 519,
    height: 238,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamPeoples);
export default __webpack_public_path__ + "static/media/TeamPeoples.3471351044b05b35d5bbb3ce68ac8c3e.svg";
export { ForwardRef as ReactComponent };